import {NgModule, ErrorHandler} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {NavigationEnd, Router} from '@angular/router';
import {DatePipe} from '@angular/common';

import {
  GoogleAnalyticsService,
  NgxGoogleAnalyticsModule,
  NgxGoogleAnalyticsRouterModule,
} from 'ngx-google-analytics';

import {AppRoutingModule} from './app-routing.module';
import {CustomErrorHandler} from './custom-error-handler';
import {AppComponent} from './app.component';
import {ComponentsModule} from './components/components.module';
import {environment} from 'environments/environment';
import {filter} from 'rxjs/operators';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    ComponentsModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    NgxGoogleAnalyticsModule.forRoot(environment.ga),
    NgxGoogleAnalyticsRouterModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: CustomErrorHandler,
    },
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(
    private router: Router,
    private ga: GoogleAnalyticsService,
  ) {
    this.tarckRoutingEvent();
  }

  tarckRoutingEvent() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.ga.pageView(event.url);
      });
  }
}
